import type { TowerDesign } from "@/game/towerSpec";
/** EXACT: India TEC 40m four-legged narrow-base tower, square base, tapered throughout, angle members (Fe410 ~ A572). Base width ~2.5m/top ~1.0m estimated. */
export const design: TowerDesign = {
  id: "selfsupport-in-tec-40m",
  name: "Self-Support (India TEC 40 m)",
  description: "Real 40 m four-legged square narrow-base cellular tower, India TEC standard.",
  author: "reference: 02_engineering_drawings",
  spec: {
    type: "lattice",
    height: 40,
    stack: { faces: 4, panels: 12, baseRadius: 1.77, topRadius: 0.71,
      legSection: "angleL6", braceSection: "braceHeavy", legMaterial: "a572", braceMaterial: "a36", bracing: "X" },
    foundation: { soil: "dense-sand", base: { type: "pad", width: 2.5, diameter: 1, depth: 2.5, concrete: "c30" },
      connection: { kind: "anchorBolts", nBolts: 8, bolt: "b1_5", grade: "f1554_55", boltCircleDia: 0.7, embedment: 0.8, edgeDistance: 0.35, platePlanArea: 0.5, plateThickness: 0.045, plateGrade: "a36rod", fc: 30e6 } },
  },
};
